<template>
  <b-modal
    id="testimonial-modal"
    centered
    title="Työtodistus"
    ok-title="Luo"
    cancel-title="Peruuta"
    modal-class="modal-primary"
    no-close-on-backdrop
    @ok="createTestimonial"
  >
    <div style="display: flex; flex-direction: row; justify-content: space-between;">
      <b-form-group label="Alkaa">
        <flat-pickr
          v-model="start"
          class="form-control"
        />
      </b-form-group>
      <b-form-group label="Loppuu">
        <flat-pickr
          v-model="end"
          class="form-control"
        />
      </b-form-group>
    </div>
    <div>
      <p v-if="hours">{{ `Tehdyt työtunnit: ${hours}` }}</p>
    </div>
  </b-modal>
</template>

<script>
  import {BModal, BFormGroup} from 'bootstrap-vue'
  import flatPickr from 'vue-flatpickr-component'
  import { db } from '@/shared/services/firebase'

  export default {
    components: {
      BModal,
      BFormGroup,
      flatPickr,
    },
    props: {
      userData: {
        default: null,
        type: Object,
      },
    },
    data() {
      return {
        start: '',
        end: '',
        hours: null,
      }
    },
    methods: {
      async createTestimonial(event) {
        event.preventDefault()
        try {
          this.hours = null
          this.start = new Date(`${this.start} 00:00:00`)
          this.end = new Date(`${this.end} 00:00:00`)

          const shiftsCollection = await db
            .collection('shifts')
            .where('assignedTo', '==', this.userData.id)
            .where('status', '==', 'confirmed')
            .where('start', '>=', this.start)
            .where('start', '<=', this.end)
            .get()

          const shifts = shiftsCollection.docs.map(shift => ({
            ...shift.data(),
            id: shift.id,
          }))
          
          // eslint-disable-next-line array-callback-return
          shifts.map(shift => {
            const startTime = new Date()
            startTime.setSeconds(shift.start.seconds)
            const endTime = new Date()
            endTime.setSeconds(shift.end.seconds)

            let timeDiff = endTime.getHours() - startTime.getHours()
            if (timeDiff < 0) {
              timeDiff = 24 + timeDiff
            }
            this.hours += timeDiff
          })
        } catch (e) {
          console.error(e)
        }
      },
    },
  }
</script>

<style lang="scss" scoped>

</style>